import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'antd';
import { MenuProps } from 'antd';
import { BookOutlined, FieldTimeOutlined } from '@ant-design/icons';

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
  {
    key: '1',
    icon: <FieldTimeOutlined />,
    label: 'Timesheets',
  },
  {
    key: '2',
    icon: <BookOutlined />,
    label: 'Contractors',
  },
];

const AppMenu: React.FC = (): React.ReactElement => {
  const history = useHistory();
  const onClick = (e: any): void => {
    switch (e.key) {
      case '2':
        history.push('/contractors');
        break;
      case '1':
        history.push('/timesheets');
        break;
    }
  }
  return <Menu theme="dark" mode="inline" items={items} onClick={onClick} />;
};

export default AppMenu;
